import Vue from 'vue';

/**
 * Service for consistent notification handling.
 * Standardizes the mix of $root.$emit and AlertService patterns.
 */
export default class NotificationService {
  public showSuccess(instance: Vue, message: string): void {
    (instance.$root as any).$bvToast.toast(message, {
      toaster: 'b-toaster-top-center',
      title: 'Succès',
      variant: 'success',
      solid: true,
      autoHideDelay: 5000,
    });
  }

  public showError(instance: Vue, message: string, error?: any): void {
    if (error) {
      console.error(message, error);
    }
    (instance.$root as any).$bvToast.toast(message, {
      toaster: 'b-toaster-top-center',
      title: 'Erreur',
      variant: 'danger',
      solid: true,
      autoHideDelay: 5000,
    });
  }

  public showInfo(instance: Vue, message: string): void {
    (instance.$root as any).$bvToast.toast(message, {
      toaster: 'b-toaster-top-center',
      title: 'Information',
      variant: 'info',
      solid: true,
      autoHideDelay: 5000,
    });
  }

  public showWarning(instance: Vue, message: string): void {
    (instance.$root as any).$bvToast.toast(message, {
      toaster: 'b-toaster-top-center',
      title: 'Attention',
      variant: 'warning',
      solid: true,
      autoHideDelay: 5000,
    });
  }

  /**
   * Handle HTTP errors with appropriate user messages
   */
  public handleApiError(instance: Vue, error: any, defaultMessage: string): void {
    const message = error?.response?.data?.message || defaultMessage;
    this.showError(instance, message, error);
  }
}
